// Mobile numbers on the sign-in page (D-079): the countries offered, how each groups its digits, and what counts as
// a mobile number there. Only the server decides whether a number gets a code (AUTH-14).

export interface Country {
  iso: string;
  name: string;
  dial: string;
  len: number;
  placeholder: string;
  group: number[];
}

export const COUNTRIES: Country[] = [
  { iso: "IN", name: "India", dial: "+91", len: 10, placeholder: "98201 44372", group: [5, 5] },
  { iso: "AE", name: "United Arab Emirates", dial: "+971", len: 9, placeholder: "50 123 4567", group: [2, 3, 4] },
  { iso: "SA", name: "Saudi Arabia", dial: "+966", len: 9, placeholder: "50 123 4567", group: [2, 3, 4] },
  { iso: "NP", name: "Nepal", dial: "+977", len: 10, placeholder: "98412 34567", group: [5, 5] },
  { iso: "BD", name: "Bangladesh", dial: "+880", len: 10, placeholder: "1712 345678", group: [4, 6] },
  { iso: "LK", name: "Sri Lanka", dial: "+94", len: 9, placeholder: "71 234 5678", group: [2, 3, 4] },
  { iso: "SG", name: "Singapore", dial: "+65", len: 8, placeholder: "8123 4567", group: [4, 4] },
  { iso: "GB", name: "United Kingdom", dial: "+44", len: 10, placeholder: "7400 123456", group: [4, 6] },
  { iso: "US", name: "United States", dial: "+1", len: 10, placeholder: "201 555 0123", group: [3, 3, 4] },
  { iso: "AU", name: "Australia", dial: "+61", len: 9, placeholder: "412 345 678", group: [3, 3, 3] },
];

/** A number's digits in the country's usual groups: "98201 44372". */
export function groupDigits(digits: string, group: number[]): string {
  const out: string[] = [];
  let i = 0;
  for (const n of group) {
    if (i >= digits.length) break;
    out.push(digits.slice(i, i + n));
    i += n;
  }
  return out.join(" ");
}

/** Whether a number can be a mobile number of the country: its length, and in India a first digit of 6 to 9. */
export function validMobile(country: Country, digits: string): boolean {
  return digits.length === country.len && (country.iso !== "IN" || /^[6-9]/.test(digits));
}

/**
 * The national number in what a person typed or pasted, cut to the country's length. A pasted country code
 * ("+91 98201 44372", "0091 98201 44372", "919820144372") and a trunk zero ("098201 44372") are dropped.
 */
export function cleanDigits(raw: string, country: Country): string {
  const code = country.dial.slice(1);
  const digits = raw.replace(/\D/g, "").replace(/^0+/, "");
  const withCode = digits.startsWith(code) &&
    (/^\s*(\+|00)/.test(raw) ? digits.length > country.len : digits.length === country.len + code.length);
  return (withCode ? digits.slice(code.length) : digits).replace(/^0+/, "").slice(0, country.len);
}
